
      import { defu } from 'defu'
      const matcher = /* @__PURE__ */ (() => { const $0={ssr: false};; return (m,p)=>{let r=[];if(p.charCodeAt(p.length-1)===47)p=p.slice(0,-1)||"/";if(p==="/nuxt/callback"){r.unshift({data:$0});}let s=p.split("/"),l=s.length;r.unshift({data:$0,params:{"_":s.slice(1).join('/'),}});return r;}})()
      export default (path) => defu({}, ...matcher('', typeof path === 'string' ? path.toLowerCase() : path).map(r => r.data).reverse())
      